module.exports = __webpack_public_path__ + "img/logo-gestão-pessoas-mobile.36606444.svg";